import React, { useEffect } from 'react';
// import hoistNonReactStatics from 'hoist-non-react-statics';
import { ReactReduxContext } from 'react-redux';

import getInjectors from './sagaInjector';

/**
 * Dynamically injects a saga
 */

const useInjectSaga = ({ key, saga }) => {
  const context = React.useContext(ReactReduxContext);
  /* eslint-disable */
  useEffect(() => {
    const injectors = getInjectors(context.store);

    injectors.injectSaga(key, { saga });
  }, []);
  /* eslint-enable */
};

export { useInjectSaga };
